module.exports = __webpack_public_path__ + "static/media/slider6.5e9ad2c7.png";